// Meta (Facebook) Pixel helpers. The pixel ID is configured per campaign, so the base code is
// injected at runtime rather than hard-coded in index.html.

const PIXEL_ID_PATTERN = /^\d{5,20}$/;

export const isValidPixelId = (pixelId) => PIXEL_ID_PATTERN.test(String(pixelId || '').trim());

// Standard Meta Pixel base snippet, equivalent to the code Meta provides.
const installBaseCode = () => {
  if (window.fbq) return;
  const fbq = function () {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, arguments);
    } else {
      fbq.queue.push(arguments);
    }
  };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
};

const initialisedPixels = new Set();

// Safe to call repeatedly: each pixel ID is initialised (and PageView fired) once per page load.
export const initMetaPixel = (pixelId) => {
  const id = String(pixelId || '').trim();
  if (!isValidPixelId(id) || initialisedPixels.has(id)) return false;
  installBaseCode();
  window.fbq('init', id);
  window.fbq('track', 'PageView');
  initialisedPixels.add(id);
  return true;
};

export const trackMetaEvent = (eventName, pixelId) => {
  const id = String(pixelId || '').trim();
  if (!isValidPixelId(id) || typeof window.fbq !== 'function') return;
  window.fbq('track', eventName);
};
